export default __webpack_public_path__ + "static/media/login-bg.a741c506.png";